export default "__VITE_ASSET__zvyZT24t__"